import {useEffect, useState} from 'react';
import {Alert, Button, Container, Form, Spinner, Table} from 'react-bootstrap';
import {getJobTypeOptions, saveJobTypeOption} from '../../service/JobTypeService';

export default function JobTypeSettings() {
    const [rows, setRows] = useState([]);
    const [name, setName] = useState('');
    const [loading, setLoading] = useState(true);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const [notice, setNotice] = useState('');
    const [reload, setReload] = useState(0);

    useEffect(() => {
        let active = true;
        setLoading(true);
        setError('');
        getJobTypeOptions(true).then(value => { if (active) setRows(value); })
            .catch(cause => { if (active) setError(cause.message); })
            .finally(() => { if (active) setLoading(false); });
        return () => { active = false; };
    }, [reload]);

    function change(id, patch) {
        setRows(current => current.map(row => row.id === id ? {...row, ...patch} : row));
    }

    async function save(value) {
        if (busy) return;
        const trimmed = value.name.trim();
        if (!trimmed || trimmed.length > 120) { setError('Enter a Job Type name of 1 to 120 characters.'); return; }
        setBusy(true);
        setError('');
        setNotice('');
        try {
            const saved = await saveJobTypeOption({...value, name: trimmed});
            setRows(current => value.id ? current.map(row => row.id === saved.id ? saved : row) : [...current, saved]);
            if (!value.id) setName('');
            setNotice('Job Type saved.');
        } catch (cause) { setError(cause.message); }
        finally { setBusy(false); }
    }

    return <Container className="py-4">
        <h1 className="h5 mb-3">Job Types</h1>
        {error ? <Alert variant="danger">{error}<Button variant="link" disabled={busy || loading} onClick={() => setReload(value => value + 1)}>Reload</Button></Alert> : null}
        {notice ? <Alert variant="success" role="status">{notice}</Alert> : null}
        {loading ? <Spinner animation="border" role="status" aria-label="Loading Job Types" /> : <fieldset disabled={busy}>
            <Form className="d-flex gap-2 mb-3" onSubmit={event => { event.preventDefault(); void save({name, status: 'ACTIVE'}); }}>
                <Form.Control aria-label="New Job Type name" placeholder="New Job Type" value={name} maxLength={120} required onChange={event => setName(event.target.value)} />
                <Button type="submit">Add</Button>
            </Form>
            <Table responsive>
                <thead><tr><th>Name</th><th>Status</th><th>Action</th></tr></thead>
                <tbody>{rows.map(row => <tr key={row.id}>
                    <td><Form.Control aria-label={`Job Type ${row.id} name`} value={row.name} maxLength={120} onChange={event => change(row.id, {name: event.target.value})} />
                        {row.is_default ? <span className="text-muted">Default</span> : null}</td>
                    <td><Form.Select aria-label={`Status for ${row.name}`} value={row.status} disabled={row.is_default} onChange={event => change(row.id, {status: event.target.value})}>
                        <option value="ACTIVE">Active</option><option value="INACTIVE">Inactive</option>
                    </Form.Select></td>
                    <td><Button variant="outline-primary" onClick={() => void save(row)}>Save</Button></td>
                </tr>)}</tbody>
            </Table>
        </fieldset>}
    </Container>;
}
